import React, { memo, forwardRef, useImperativeHandle, useRef } from 'react'

export type ViewShotRef = {
  takePicture: () => Promise<string>
  children: React.ReactNode
}
export type ViewShotProps = {
  children: React.ReactNode
  width: number
  height?: number
}
import html2canvas from 'html2canvas'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function createImages(captureRefChart: any) {
  let images = null

  if (captureRefChart && captureRefChart.length > 0) {
    images = []
    for (let index = 0; index < captureRefChart.length; index++) {
      if (captureRefChart && captureRefChart[index].current) {
        try {
          const canvas = await html2canvas(captureRefChart[index].current, {
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
            scale: 2, // Higher quality for better image
            logging: false,
            width: 600,
            height: 500
          })
          //@ts-ignore
          images.push(canvas.toDataURL('image/png', 0.9))
        } catch (error) {
          // Fallback to lower quality if needed
          const canvas = await html2canvas(captureRefChart[index].current, {
            useCORS: false,
            allowTaint: true,
            backgroundColor: '#ffffff',
            scale: 1
          })
          //@ts-ignore
          images.push(canvas.toDataURL('image/png', 0.8))
        }
      }
    }
  }
  return images
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ViewShotLine = forwardRef<any, ViewShotProps>(({ children, height: _height }: ViewShotProps, ref: any) => {
  const viewShot = useRef(null)
  useImperativeHandle(ref, () => ({
    takePicture: async () => {
      return await createImages([viewShot])
    }
  }))
  return <div ref={viewShot}>{children}</div>
})
export default memo(ViewShotLine)
